var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "zuke_index" },
    [
      _c("div", { staticClass: "footer_box" }, [
        _c("div", { staticClass: "footer_fixed" }, [
          _c("div", { staticClass: "footer" }, [
            _c(
              "div",
              {
                staticClass: "footer_list",
                on: {
                  click: function($event) {
                    return _vm.footer_btn("/baike")
                  }
                }
              },
              [
                _vm.result == "baike"
                  ? _c("img", {
                      staticClass: "footer_img active",
                      attrs: {
                        src: require("../../assets/images/index_on.png")
                      }
                    })
                  : _vm._e(),
                _vm.result != "baike"
                  ? _c("img", {
                      staticClass: "footer_img",
                      attrs: { src: require("../../assets/images/index.png") }
                    })
                  : _vm._e(),
                _c("div", { staticClass: "footer_title" }, [_vm._v("首页")])
              ]
            ),
            _c(
              "div",
              {
                staticClass: "footer_list",
                on: {
                  click: function($event) {
                    return _vm.footer_btn("/baike/guide")
                  }
                }
              },
              [
                _c("img", {
                  staticClass: "footer_img",
                  attrs: { src: require("../../assets/images/add.png") }
                }),
                _c("div", { staticClass: "footer_title" }, [_vm._v("创建词条")])
              ]
            ),
            _c(
              "div",
              {
                staticClass: "footer_list",
                on: {
                  click: function($event) {
                    return _vm.footer_btn("/baike/personal")
                  }
                }
              },
              [
                _vm.result == "personal"
                  ? _c("img", {
                      staticClass: "footer_img",
                      attrs: { src: require("../../assets/images/my_on.png") }
                    })
                  : _vm._e(),
                _vm.result != "personal"
                  ? _c("img", {
                      staticClass: "footer_img",
                      attrs: { src: require("../../assets/images/my.png") }
                    })
                  : _vm._e(),
                _c("div", { staticClass: "footer_title" }, [_vm._v("我的")])
              ]
            )
          ])
        ])
      ]),
      _c("PasswordPop", {
        ref: "mychild",
        attrs: { passwordPop: _vm.passwordPop }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/views/encyclopedia/footerBox.vue?vue&type=template&id=59d63ddb&scoped=true&
// module id = 268
// module chunks = 0 1